import PullToRefresh from "@/components/PullToRefresh";
import { runRefreshCallbacks } from "@/hooks/useRefreshListener";

// Detecta si hay un overlay abierto (modal/sheet/drawer/popover) evaluando al
// momento del toque — sin MutationObserver ni estado reactivo. Reemplaza la
// lógica per-page de `disabled={!!modal}` por una sola comprobación global.
function isOverlayOpen() {
  return !!document.querySelector(
    '[role="dialog"],[aria-modal="true"],[data-sheet-open="true"],[data-drawer-open="true"],[data-state="open"]'
  );
}

// Wrapper global de pull-to-refresh: se monta una sola vez en App.jsx y cubre
// TODA la app (plataforma, landing, tienda, páginas públicas). Las páginas
// dinámicas participan vía `useRefreshListener(load)`; las estáticas ignoran
// el gesto (el spinner aparece brevemente y se oculta).
export default function GlobalPullToRefresh({ children }) {
  return (
    <PullToRefresh onRefresh={runRefreshCallbacks} disabledFn={isOverlayOpen}>
      {children}
    </PullToRefresh>
  );
}